export const sampleActivityList = {
  meta: {
    count: 105,
    page: 1,
    pagesize: 20,
    lang: 'en',
    columns: [
      {
        key: 'title',
        title: 'Title',
        searchable: true,
        sortable: true,
        visible: true,
        type: 'string',
        options: []
      },
      {
        key: 'type',
        title: 'Type',
        searchable: true,
        sortable: true,
        visible: true,
        type: 'string',
        options: [
          {
            label: 'Preventive Maintenance',
            type: 'Preventive Maintenance'
          },
          {
            label: 'Break Down',
            type: 'Break Down'
          },
          {
            label: 'Special Request',
            type: 'Special Request'
          }
        ]
      },
      {
        key: 'description',
        title: 'Description',
        // searchable: true,
        sortable: true,
        visible: true,
        type: 'string',
        options: []
      },
      {
        key: 'createdOn',
        title: 'Created On',
        searchable: true,
        // sortable: true,
        visible: true,
        type: 'DateTime',
        options: []
      }
    ]
  },
  data: [
    {
      activityId: 1,
      title: 'Any Day PM-1',
      type: 'Spare',
      description: '<p><br></p>',
      CreatedBy: 'Santosh',
      UpdatedBy: 'akhil',
      createdOn: '2022-11-02T16:24:32.567',
      UpdatedOn: '2022-11-17T15:38:25.91'
    },
    {
      activityId: 2,
      title: 'PM Yearly',
      type: 'Preventive Maintenance',
      description: '<p>PM Yearly Activity for Preventive Maintenance</p>',
      CreatedBy: 'Santosh',
      UpdatedBy: 'md.akhil@panorbit.in',
      createdOn: '2022-11-02T16:25:26.007',
      UpdatedOn: '2022-11-17T17:13:19.617'
    },
    {
      activityId: 3,
      title: 'PM Daily Activity.',
      type: 'Part Request(Quick)',
      description: '<p><br></p>',
      CreatedBy: 'Santosh',
      UpdatedBy: 'md.akhil@panorbit.in',
      createdOn: '2022-11-02T16:25:48.78',
      UpdatedOn: '2022-11-18T17:49:03.907'
    },
    {
      activityId: 4,
      title: 'Bi_weekly Activit',
      type: 'Break Down',
      description: '<p>tested</p>',
      CreatedBy: 'Santosh',
      UpdatedBy: 'md.akhil@panorbit.in',
      createdOn: '2022-11-02T16:26:04.02',
      UpdatedOn: '2022-11-17T10:00:33.043'
    },
    {
      activityId: 5,
      title: 'PM Yearly activity.',
      type: 'Prt return',
      description: '<p>Updated Activity for Break Down</p>',
      CreatedBy: 'Santosh',
      UpdatedBy: 'md.akhil@panorbit.in',
      createdOn: '2022-11-02T16:26:17.41',
      UpdatedOn: '2022-11-17T15:56:46.233'
    },
    {
      activityId: 6,
      title: 'Monthly Activity - changed',
      type: 'Break Down',
      description: 'description is updated by Arun',
      CreatedBy: 'Santosh',
      UpdatedBy: 'Santosh.Ganapati@vistrian.com',
      createdOn: '2022-11-02T16:26:36.533',
      UpdatedOn: '2022-11-02T16:26:36.533'
    },
    {
      activityId: 7,
      title: 'Half-Yearly Activity',
      type: 'Break Down',
      description: '<p>Half Yearly Activity</p>',
      CreatedBy: 'Santosh',
      UpdatedBy: 'md.akhil@panorbit.in',
      createdOn: '2022-11-02T16:27:03.47',
      UpdatedOn: '2022-11-15T20:03:50.19'
    },
    {
      activityId: 8,
      title: 'Weekly PM',
      type: 'Break Down',
      description: 'Activity for Break Down - Weekly PM',
      CreatedBy: 'Santosh',
      UpdatedBy: 'Santosh.Ganapati@vistrian.com',
      createdOn: '2022-11-02T16:27:19.673',
      UpdatedOn: '2022-11-02T16:27:19.673'
    },
    {
      activityId: 9,
      title: 'Weekly PM',
      type: 'Preventive Maintenance',
      description: 'Activity for Preventive Maintenance - Weekly PM',
      CreatedBy: 'Santosh',
      UpdatedBy: 'Santosh.Ganapati@vistrian.com',
      createdOn: '2022-11-02T16:27:35.05',
      UpdatedOn: '2022-11-02T16:27:35.05'
    },
    {
      activityId: 10,
      title: 'Weekly PM',
      type: 'Break Down',
      description: 'Activity for Break Down - Weekly PM',
      CreatedBy: 'Santosh',
      UpdatedBy: 'Santosh.Ganapati@vistrian.com',
      createdOn: '2022-11-08T16:57:05.667',
      UpdatedOn: '2022-11-08T16:57:05.667'
    },
    {
      activityId: 11,
      title: 'Weekly PM',
      type: 'Break Down',
      description: 'Activity for Break Down - Weekly PM',
      CreatedBy: 'Santosh',
      UpdatedBy: 'Santosh.Ganapati@vistrian.com',
      createdOn: '2022-11-08T17:42:51.753',
      UpdatedOn: '2022-11-08T17:42:51.753'
    },
    {
      activityId: 12,
      title: 'Weekly PM',
      type: 'Break Down',
      description: 'Activity for Break Down - Weekly PM',
      CreatedBy: 'Santosh',
      UpdatedBy: 'Santosh.Ganapati@vistrian.com',
      createdOn: '2022-11-08T19:02:30.91',
      UpdatedOn: '2022-11-08T19:02:30.91'
    },
    {
      activityId: 13,
      title: 'test',
      type: 'Spare',
      description: '<p>test</p>',
      CreatedBy: 'Mohammad Akhil',
      UpdatedBy: 'akhil',
      createdOn: '2022-11-08T19:51:48.23',
      UpdatedOn: '2022-11-16T17:13:33.53'
    },
    {
      activityId: 14,
      title: 'test1',
      type: 'Break Down',
      description: '<p><span style="color: rgb(230, 0, 0);">test1</span></p>',
      CreatedBy: 'Mohammad Akhil',
      UpdatedBy: 'md.akhil@panorbit.in',
      createdOn: '2022-11-08T20:26:18.933',
      UpdatedOn: '2022-11-10T10:36:18.353'
    },
    {
      activityId: 15,
      title: 'test',
      type: 'Preventive Maintenance',
      description: '<p><s>test</s></p>',
      CreatedBy: 'Mohammad Akhil',
      UpdatedBy: 'md.akhil@panorbit.in',
      createdOn: '2022-11-09T18:51:38.56',
      UpdatedOn: '2022-11-09T18:51:38.56'
    },
    {
      activityId: 16,
      title: 'test-2',
      type: 'Spare',
      description: '<p><em>test</em></p>',
      CreatedBy: 'Mohammad Akhil',
      UpdatedBy: 'md.akhil@panorbit.in',
      createdOn: '2022-11-09T19:00:11.19',
      UpdatedOn: '2022-11-09T19:00:11.19'
    },
    {
      activityId: 17,
      title: 'Weekly PM-1',
      type: 'Break Down',
      description: '<p>Activity for Preventive Maintenance - Weekly PM</p>',
      CreatedBy: 'Santosh',
      UpdatedBy: 'md.akhil@panorbit.in',
      createdOn: '2022-11-09T20:07:16.903',
      UpdatedOn: '2022-11-15T12:49:00.527'
    },
    {
      activityId: 18,
      title: 'test3',
      type: 'Preventive Maintenance',
      description: '<p><span style="color: rgb(230, 0, 0);">test3?</span></p>',
      CreatedBy: 'Mohammad Akhil',
      UpdatedBy: 'md.akhil@panorbit.in',
      createdOn: '2022-11-10T12:39:30.44',
      UpdatedOn: '2022-11-15T19:57:38.037'
    },
    {
      activityId: 19,
      title: 'test',
      type: 'Break Down',
      description: '<p>test</p>',
      CreatedBy: 'Mohammad Akhil',
      UpdatedBy: 'akhil',
      createdOn: '2022-11-11T13:24:26.773',
      UpdatedOn: '2022-11-16T19:44:31.197'
    },
    {
      activityId: 20,
      title: 'test',
      type: '',
      description: '<p>test<span style="color: rgb(230, 0, 0);">1ew</span></p>',
      CreatedBy: 'Mohammad Akhil',
      UpdatedBy: 'md.akhil@panorbit.in',
      createdOn: '2022-11-14T19:44:33.993',
      UpdatedOn: '2022-11-15T20:45:45.47'
    }
  ]
};
